
import * as c from "../common.js";
import { extractFilenameFromContentDisposition } from "./compress-util.js";
import {notifyError} from "./utils.js";

export let accessToken = null;
let tokenClient = null;
export let pickerApiLoaded = false;
let _driveAnnotationFolder = null;
export const GDRIVE_FOLDERS = {DATA: null, APPDATA: null, TRACK_DATA: null};
const DRIVE_DATA_FOLDER = "__SailData__"
const DRIVE_APPDATA_FOLDER = "AppData";
const DRIVE_TRACK_DATA_FOLDER = "Track_Data";

const DATA_FOLDER_OBJ_KEY = 'driveDataFolderResult';
const APPDATA_FOLDER_OBJ_KEY = 'driveAppDataFolderResult';

export const clientId = '179940480325-7hn8t06bgoa5jiiu93ma84rtfhhk6vfj.apps.googleusercontent.com';
export const developerKey = 'AIzaSyDTlurzpVeOcFYVxUIJFcpeoLwlQN0RbqA';
export const appId = "sail-data-458005";
const LOCAL_STORAGE = {
  ACCESS_TOKEN:"googleAccessToken",
  ACCESS_TOKEN_EXPIRY:"accessTokenExpiry"
}
export function isReady() { // export used in settings only
  return pickerApiLoaded && accessToken;
}

export function getDataFolder() {
  return GDRIVE_FOLDERS.DATA;
}

let _lastAuthSuccess = true;
export async function initGoogleDriveAsync(tokensuccesscallback) {
  try {
    // Auto-trigger login if not authenticated
    // removing as this just creates a cycle.
    // if (!c.sharedFileMode() && isTokenExpiredOrInvalid()) {
    //   console.log("initGoogleDriveAsync: click(), sharing:",c.sharedFileMode(), "expired:",isTokenExpiredOrInvalid());
    //   document.getElementById("g_id_signin").click();
    // }

    if (c.sharedFileMode())
      return;

    if (typeof google === 'undefined') {
      alert("Please log in to Google Drive.");
      return;
    }

    tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: clientId,
      scope: 'https://www.googleapis.com/auth/drive.file',
      callback: async (tokenResponse) => {
        console.log('initGoogleDriveAsync: Auth response:', tokenResponse);
        if (tokenResponse.error == null && parseInt(tokenResponse.expires_in) > 600) {
          accessToken = tokenResponse.access_token;
          const expiresIn = tokenResponse.expires_in;
          localStorage.setItem(LOCAL_STORAGE.ACCESS_TOKEN, accessToken);
          localStorage.setItem(LOCAL_STORAGE.ACCESS_TOKEN_EXPIRY, Date.now() + expiresIn * 1000); // Save expiry time
          console.log('initGoogleDriveAsync: Access token obtained:', accessToken);
          // document.getElementById('g_id_signin').style.display = 'none';
          _lastAuthSuccess = true;
          await ensureDataFolderAsync();
          tokensuccesscallback();
        } else {
          console.log("initGoogleDriveAsync: requesting auth with consent");
          console.log("initGoogleDriveAsync: Last response: error",tokenResponse.error, "expires in: ", tokenResponse.expires_in);
          _lastAuthSuccess = false;
          setTimeout(loadTokenOrPromptAuthAsync, 1000);
          if (_intervalId > 0)
            clearInterval(_intervalId);
        }
      }
    });
    accessToken = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN);
    if (accessToken == undefined) {
      console.log("initGoogleDriveAsync: accessToken undefined");
      tokenClient.requestAccessToken({prompt: 'none'});
    } else {
      await ensureDataFolderAsync();
    }
    await loadTokenOrPromptAuthAsync(tokensuccesscallback);
    gapi.load('picker', { 'callback': onPickerApiLoad });
  } catch (e) {
    notifyError(`Failure initalising google drive: `,e); 
  }
};

let _intervalId = -1;
async function loadTokenOrPromptAuthAsync(tokensuccesscallback) {
  if (c.sharedFileMode())
    return;

  if (!_lastAuthSuccess) {
    console.log("initGoogleDriveAsync: last login fail, request token 'consent'");
    tokenClient.requestAccessToken({prompt: 'consent'});
  } else if (isTokenExpiredOrInvalid()) {
    const prompt = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'select_account' : 'none';
    console.log("initGoogleDriveAsync: token expired, request token prompt:", prompt);
    tokenClient.requestAccessToken({prompt});
  } else if (tokensuccesscallback) {
    console.log("initGoogleDriveAsync: tokensuccesscallback exists, calling");
    await ensureDataFolderAsync();
    tokensuccesscallback();
    console.log("initGoogleDriveAsync: tokensuccesscallback finished");
  }
  // _intervalId = setInterval(loadTokenOrPromptAuth, 60000); // Check every 10 sec
}

function isTokenExpiredOrInvalid() {
  const expiryTime = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN_EXPIRY);
  accessToken = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN);
  return isInvalidStorage(accessToken) || isInvalidStorage(expiryTime) || Date.now() > expiryTime - 5*60000;
}

function isInvalidStorage(val) {
  return val == undefined || val == null || val == "undefined";
}


function onPickerApiLoad() {
  pickerApiLoaded = true;
  console.log('Picker API loaded');
}

async function loadFolder(folderName, localStorageObjKey, parentId, attemptCount=0) {
  let folder = JSON.parse(localStorage.getItem(localStorageObjKey));
  if (!folder || !folder.id) {
    if (attemptCount <= 0) {
      try {
        folder = await findFolderByNameAsync(folderName,parentId);
        if (folder == null) {
          folder = await createFolderAsync(folderName, parentId);
          console.info(`Created data folder:`+folderName);
        }
        if (localStorageObjKey !== null) {
          localStorage.setItem(localStorageObjKey, JSON.stringify(folder));
        }
      } catch (error) {
        console.info(error);
        alert("Error accessing or creating ",folderName," folder. Please log in to Google Drive.");
        loadFolder(folderName,localStorageObjKey,parentId, attemptCount + 1); // second attempt
      }
    }
  } else {
    console.info('Loaded folder from local storage:'+folderName+', id:'+folder.id+', parend id:'+parentId);
  }
  return folder;
}

export async function ensureAppDataFolderAsync() {
  GDRIVE_FOLDERS.APPDATA = await loadFolder(DRIVE_APPDATA_FOLDER, APPDATA_FOLDER_OBJ_KEY, GDRIVE_FOLDERS.DATA.id);
  return GDRIVE_FOLDERS.APPDATA;
}

export async function ensurePolarFolderAsync() {
  return await ensureAppDataFolderAsync();
}

export async function ensureTrackDataFolderAsync() {
  GDRIVE_FOLDERS.TRACK_DATA = await loadFolder(DRIVE_TRACK_DATA_FOLDER, null, GDRIVE_FOLDERS.DATA.id);
  return GDRIVE_FOLDERS.TRACK_DATA;
}

export async function ensureDataFolderAsync() {
  GDRIVE_FOLDERS.DATA = await loadFolder(DRIVE_DATA_FOLDER, DATA_FOLDER_OBJ_KEY, null);
  return GDRIVE_FOLDERS.DATA;
}

export async function uploadFilesToFolderAsync(files) {
  if (!isReady()) {
    alert('Google Drive not ready!');
    return null;
  }

  return new Promise((resolve) => {
    const view = new google.picker.DocsView()
      .setIncludeFolders(true)
      .setSelectFolderEnabled(true)
      .setMode(google.picker.DocsViewMode.LIST);

    const picker = new google.picker.PickerBuilder()
      .addView(view)
      .setOAuthToken(accessToken)
      .setDeveloperKey(developerKey)
      .setAppId(appId)
      .setCallback(async (data) => {
        if (data.action === google.picker.Action.PICKED) {
          const folder = data.docs[0];
          const uploadedFiles = [];
          for (const file of files) {
            const fileId = await uploadFileToGDriveAsync(file.name, file.type, file, {id: folder.id});
            if (fileId) {
              uploadedFiles.push({name: file.name, id: fileId});
            }
          }
          resolve(uploadedFiles);
        } else if (data.action === google.picker.Action.CANCEL) {
          resolve([]);
        }
      })
      .build();
    picker.setVisible(true);
  });
}

export async function drivePickAndDownloadFileAsync(folder, okFn, errFn = (response) => {console.log(response)}) {
  if (isReady()) {
    const view = new google.picker.DocsView()
    .setIncludeFolders(true)
    .setSelectFolderEnabled(false)
    .setMode(google.picker.DocsViewMode.LIST)
    .setMimeTypes('application/json,text/plain,application/gzip')
    // .setEnableDrives(true)
    ;
    if (folder != null) {
      view.setParent(folder.id)
    }
    
    const picker = new google.picker.PickerBuilder()
    .addView(view)
    .setOAuthToken(accessToken)
    .setDeveloperKey(developerKey)
    .setAppId(appId)
    //.enableFeature(google.picker.Feature.MINE_ONLY)
    // .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
    .setCallback((data) => {
      if (data.action === google.picker.Action.PICKED) {
        fetchFileContent(data.docs, okFn, errFn);
      } else if (data.action === google.picker.Action.CANCEL) {
        okFn({});
      }
    })
    .build();
    picker.setVisible(true);
  }
}

async function fetchFileContent(docs, okFn, errFn) {
  const res = await fetch(`https://www.googleapis.com/drive/v3/files/${docs[0].id}?alt=media`, {
    headers: new Headers({ 'Authorization': 'Bearer ' + accessToken })
  });
  
  if (res.ok) {
    okFn(res, docs[0]);
  } else {
    errFn(res)
  }
}



export async function uploadFileToGDriveAsync(fileName, mimeType, fileContent, folder) {
  console.info('Saving file: ${fileName} mime: ${mimeType} into ${folder.name}');
  await loadTokenOrPromptAuthAsync();
  if (!isReady()) {
    alert('Google Drive not ready!');
    return null;
  }
  
  if (!folder || !folder.id) {
    alert('Please select a folder for uploading.');
    return null;
  }

  const fileBlob = fileContent instanceof Blob ? fileContent : new Blob([fileContent], { type: mimeType });

  const metadata = {
    name: fileName,
    mimeType: mimeType,
    parents: [folder.id]
  };

  const form = new FormData();
  form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
  form.append('file', fileBlob);

  const res = await fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart', {
    method: 'POST',
    headers: new Headers({ 'Authorization': 'Bearer ' + accessToken }),
    body: form
  });

  const result = await res.json();

  if (res.ok && result.id) {
    console.info(`Uploaded ${fileName}`);
    return result.id;
  } else {
    console.error('Upload failed:', result);
    return null;
  }
}

export async function updateFileContentAsync(fileId, newContent, mimeType = 'application/json') {
  await loadTokenOrPromptAuthAsync();
  const fileBlob = new Blob([newContent], { type: mimeType });

  const metadata = {
    mimeType: mimeType
  };

  const form = new FormData();
  //meta data blob uses needs it's own mime type
  form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
  form.append('file', fileBlob);

  const response = await fetch(`https://www.googleapis.com/upload/drive/v3/files/${fileId}?uploadType=multipart`, {
    method: 'PATCH',
    headers: new Headers({ 'Authorization': 'Bearer ' + accessToken }),
    body: form,
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(`Failed to update file: ${error}`);
  }

  const result = await response.json();
  console.log('File updated successfully:', result);
  return result;
}

async function findFileByNameAndParentAsync(fileName, parentId, accessToken) {
  const query = `name='${fileName}' and '${parentId}' in parents and trashed=false`;
  const res = await fetch(`https://www.googleapis.com/drive/v3/files?q=${encodeURIComponent(query)}&fields=files(id,name)`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  const data = await res.json();
  if (!data.files.length) throw new Error('File not found');
  return data.files[0]; // Return the first match
}


export async function fetchFileContentAsync(fileId) {
  await loadTokenOrPromptAuthAsync();
  const headers = {Authorization: `Bearer ${accessToken}`};
  const response = await fetch(`https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`, {
    headers: headers
  });

  if (!response.ok) {
    throw new Error('Failed to fetch file content');
  }

  return await response.arrayBuffer();
}

export async function fetchSharedFileContentURLAsync(url) {
  console.log(url);
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error('Failed to fetch file content');
  }

  const data = await response.arrayBuffer();
  return { data: new Uint8Array(data), fileName: null };
}

export async function fetchSharedFileContentGDrive(id) {
  const url = `https://zugprzuta46axtfrid74jdvhe40wnddf.lambda-url.ap-southeast-2.on.aws?id=${id}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Failed to fetch file content');
  }
  const data = await response.arrayBuffer();
  let contentDisposition = null;
  for (const [key, value] of response.headers.entries()) {
    if (key.toLowerCase() === 'content-disposition') {
      contentDisposition = value;
      break;
    }
  }
  const fileName = extractFilenameFromContentDisposition(contentDisposition);
  return { data: new Uint8Array(data), fileName };
}

export async function downloadNamedFileFromDataFolderAsync(folder, fileName) {
  await loadTokenOrPromptAuthAsync();
  try {
    const file = await findFileByNameAndParentAsync(fileName, folder.id, accessToken);
    if (file != null) {
      const data = await fetchFileContentAsync(file.id);
      console.info(`Loaded ${fileName}`);
      let result = {data: new Uint8Array(data), id: file.id};
      return result;
    } else {
      console.log("Not found: "+fileName);
      return null;
    }
  } catch (err) {
    console.info(`Could not find ${fileName}, see error: ${err.message}`);
    return null;
  }
}


async function createFolderAsync(folderName, parentFolderId) {
  const metadata = {
    name: folderName,
    mimeType: 'application/vnd.google-apps.folder'
  };
  if (parentFolderId != undefined && parentFolderId != null) {
    metadata.parents= [parentFolderId];
  }

  const response = await fetch('https://www.googleapis.com/drive/v3/files', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(metadata)
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(`Failed to create folder: ${error.error.message}`);
  }

  const folder = await response.json();
  console.log('Created folder:', folder);
  return folder;
}

export async function deleteFileAsync(fileId) {
  await loadTokenOrPromptAuthAsync();
  try {
    const response = await fetch(`https://www.googleapis.com/drive/v3/files/${fileId}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (response.ok) {
      console.log(`File with ID ${fileId} deleted successfully.`);
    } else {
      const error = await response.json();
      console.error('Failed to delete file:', error);
    }
  } catch (err) {
    console.error('Error deleting file:', err);
  }
}

async function findFolderByNameAsync(folderName, parentId) {
  let query;
  if (parentId == null) {
    query = encodeURIComponent(
      `name = '${folderName}' and mimeType = 'application/vnd.google-apps.folder' and trashed = false`
    );
  } else {
    query = encodeURIComponent(
      `name = '${folderName}' and mimeType = 'application/vnd.google-apps.folder' and '${parentId}' in parents and trashed = false`
    );
  }

  const url = `https://www.googleapis.com/drive/v3/files?q=${query}&fields=files(id,name)`;

  try {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const data = await response.json();
    if (!data.files || data.files.length === 0) {
      console.log(`No folder named '${folderName}' found in parent ${parentId}`);
      return null;
    }
    
    // Return the first matching folder (or modify to return all if needed)
    return data.files[0];
  } catch (err) {
    console.error('Error finding folder:', err);
    return null;
  }
}

export async function listFolderContentsAsync(folder) {
  await loadTokenOrPromptAuthAsync();
  const res = await fetch(
    `https://www.googleapis.com/drive/v3/files?q='${folder.id}'+in+parents&fields=files(id,name,mimeType)`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      }
    }
  );

  if (res.ok) {
    const result = await res.json();
    // console.log("Folder contents:", result.files);
    // alert(`Found ${result.files.length} items. See console.`);
    return result;
    // document.getElementById("dirListing");
  } else {
    alert("Failed to list folder contents");
  }
}

export async function getFilePermissions(fileId) {
  await loadTokenOrPromptAuthAsync();
  const res = await fetch(
    `https://www.googleapis.com/drive/v3/files/${fileId}/permissions?fields=permissions(id,type,role)`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      }
    }
  );

  if (!res.ok) {
    const error = await res.json();
    throw new Error(`Failed to get file permissions: ${error.error?.message || res.statusText}`);
  }

  const result = await res.json();
  return result.permissions || [];
}

/**
 * Checks if a file is already shared with public read access
 * @param {string} fileId - Google Drive file ID
 * @returns {Promise<boolean>}
 */
export async function isFileShared(fileId) {
  const permissions = await getFilePermissions(fileId);
  return permissions.some(permission =>
    permission.type === 'anyone' && permission.role === 'reader'
  );
}

/**
 * Creates a permission for anyone with the link to read the file
 * @param {string} fileId - Google Drive file ID
 * @returns {Promise<Object>} - Created permission object
 */
export async function createPublicReadPermission(fileId) {
  await loadTokenOrPromptAuthAsync();
  
  const res = await fetch(
    `https://www.googleapis.com/drive/v3/files/${fileId}/permissions`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        type: 'anyone',
        role: 'reader',
        allowFileDiscovery: false
      })
    }
  );

  if (!res.ok) {
    const error = await res.json();
    throw new Error(`Failed to create public read permission: ${error.error?.message || res.statusText}`);
  }

  const result = await res.json();
  return result;
}

